import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Contact } from './contact';


@JsonObject('ContactSearchResults')
export class ContactSearchResults extends SearchResults {
    @JsonProperty('results', [Contact])
    results: Contact[] = [];
}
